import { getState } from '../../store';

export const isWidgetExpanded = (): boolean => {
  const {
    widget: { expanded },
  } = getState();

  return expanded;
};
